import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';
import { ConciergeInitVariables } from './concierge.interface';

export interface CheckInModel extends BaseModel {
  variables?: { [key: string]: string } | CheckInVariables;
}

export interface CheckInVariables {
  CheckInHeading: string;
  CheckInText: string;
  CheckInImage: string;
  CheckInImageHref: string;
  CheckInImageAlt: string;
  CheckInCtaLink: string;
  CheckInCtaText: string;
  CheckInImageHrefSegmentRegex: string;
  CheckInCtaLinkSegmentRegex: string;
}

export class CheckInInitVariables implements CheckInVariables {
  CheckInHeading = '';
  CheckInText = '';
  CheckInImage = '';
  CheckInImageHref = '';
  CheckInImageAlt = '';
  CheckInCtaLink = '';
  CheckInCtaText = '';
  CheckInImageHrefSegmentRegex = '';
  CheckInCtaLinkSegmentRegex = '';
}

export class CheckInInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new CheckInInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
